import { InputAdornment, TextField } from "@mui/material";
import {
  SizingWrapper,
  type SizingWrapperStyle,
} from "@/components/Wrapper/SizingWrapper";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import React, { type ReactElement } from "react";
import { type Control, Controller, type FieldValues } from "react-hook-form";
import type { FieldPath } from "react-hook-form/dist/types";

interface IProps<T extends FieldValues> {
  control: Control<T> | undefined;
  name: FieldPath<T>;
  size?: SizingWrapperStyle;
  hideHelpIcon?: boolean;
  autoFocus?: boolean;
}

/**
 * 識別名を入力するテキストフィールド
 * RHF向けにコントロール化されています
 */
const CTextFieldIdentifyName = <T extends FieldValues>(
  props: IProps<T>
): ReactElement => {
  const { control, name, size, hideHelpIcon, autoFocus } = props;

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>): void => {
    const target = e.target;
    target.setSelectionRange(target.value.length, target.value.length);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onChange, onBlur, ref, disabled },
        fieldState,
      }) => {
        return (
          <SizingWrapper size={size}>
            <TextField
              id="identifyName"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              disabled={disabled}
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
              label="識別名"
              fullWidth={true}
              autoFocus={autoFocus}
              onFocus={handleFocus}
              InputProps={
                hideHelpIcon
                  ? undefined
                  : {
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip
                            title={
                              <>
                                管理しやすい任意の名称をご入力ください
                                <br />
                                入力した名称は、後ほど画面でご確認いただけます
                              </>
                            }
                            placement="bottom"
                          >
                            <HelpIcon />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }
              }
            />
          </SizingWrapper>
        );
      }}
    />
  );
};
export { CTextFieldIdentifyName };
